module.exports = __webpack_public_path__ + "img/contact-us-close-button.b2837049.png";